/* eslint-disable check-file/filename-blocklist, import/no-commonjs */
/** This file is used in conjunction with the less.js script to automatically
 * create css variables named --mdb-<key of one of these objects>
 *
 * Since this is used by less.js, it is node-friendly. Any deps here should
 * be added to the //client/packages/theme:colors filegroup.
 *
 * DO NOT add new leafygreenColors, please add new customColors
 */
const { palette } = require('@leafygreen-ui/palette');

const leafygreenColors = {
  gray: palette.gray.base,
  grayDark1: palette.gray.dark1,
  grayDark2: palette.gray.dark2,
  grayDark3: palette.gray.dark3,
  grayDark4: palette.gray.dark4,
  grayLight1: palette.gray.light1,
  grayLight2: palette.gray.light2,
  grayLight3: palette.gray.light3,
  green: palette.green.base,
  greenDark1: palette.green.dark1,
  greenDark2: palette.green.dark2,
  greenDark3: palette.green.dark3,
  greenLight1: palette.green.light1,
  greenLight2: palette.green.light2,
  greenLight3: palette.green.light3,
  white: palette.white,
  black: palette.black,
  purpleDark2: palette.purple.dark2,
  purpleDark3: palette.purple.dark3,
  purple: palette.purple.base,
  purpleLight2: palette.purple.light2,
  purpleLight3: palette.purple.light3,
  blueDark1: palette.blue.dark1,
  blueDark2: palette.blue.dark2,
  blueDark3: palette.blue.dark3,
  blue: palette.blue.base,
  blueLight1: palette.blue.light1,
  blueLight2: palette.blue.light2,
  blueLight3: palette.blue.light3,
  yellowDark2: palette.yellow.dark2,
  yellowDark3: palette.yellow.dark3,
  yellow: palette.yellow.base,
  yellowLight2: palette.yellow.light2,
  yellowLight3: palette.yellow.light3,
  redDark2: palette.red.dark2,
  redDark3: palette.red.dark3,
  red: palette.red.base,
  redLight1: palette.red.light1,
  redLight2: palette.red.light2,
  redLight3: palette.red.light3,
};

const customColors = {
  chartsBlue1: '#b5d5ff',
  chartsBlue2: '#016ee9',
  chartsGreen1: '#12824d',
  chartsOrange1: '#d83713',
  lgCodeLightGreenString: '#35de7b',
  lgCodeLightBlue: '#2dc4ff',
  lgCodeLightOrangeVariable: '#ff6f44',
  uiAccessListInheritanceDarkModeBackground: '#1c2d38',
}; // Fill in new custom colors here!

module.exports = { leafygreenColors, customColors };
